import React from "react"
import PropTypes from "prop-types"
import { createGlobalStyle, ThemeProvider } from "styled-components"
import { Helmet } from "react-helmet"
import withTranslation from "../i18n/withTranslation"

import Header from "./Header"
import Footer from "./Footer"
import Transition from "./Transition"
import * as fonts from "../assets/fonts/fonts"

const GlobalStyle = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: inherit;
  }

  @font-face {
    font-family: "Gotham";
    font-style: normal;
    font-weight: normal;
    src: url(${fonts.GothamBookTTF}) format("truetype");
  }

  @font-face {
    font-family: "Gotham";
    font-style: normal;
    font-weight: 100;
    src: url(${fonts.GothamXLightTTF}) format("truetype");
  }

  body {
    box-sizing: border-box;
    margin: 0;
    font-family: "Gotham", sans-serif;
    overflow-x: hidden;
    transition: background-image .5s ease;

    input {
      border-color: #616161
    }
  }

  .mainWrapper {
    padding: 50px 0;
  }

  .slider-button {
    background: transparent;
    appearance: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    opacity: .5;
    transition: all .3s ease;
    display: inline-block;
    border: solid black;
    border-width: 0 5px 5px 0;
    padding: 3px;
    width: 20px;
    height: 20px;
    color: transparent;
    transform: rotate(135deg);
    z-index: 999;

    &:hover {
      opacity: 1;
    }

    &:focus {
      outline: 0;
    }

    &.-left {
      left: 30px;
      transform: rotate(135deg);
    }

    &.-right {
      right: 30px;
      transform: rotate(-45deg);
    }
  }
`

export const theme = {
  fontSizes: [12, 14, 16, 24, 32, 48, 64],
  breakpoints: ["40em", "52em", "64em"],
  heading: "Gotham",
  fonts: {
    heading: "Gotham",
  },
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25,
  },
  colors: {
    primary: "#000",
    gray: "#f6f6ff",
    info: "#565959",
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      borderRadius: 0,
      px: 4,
      textTransform: "uppercase",
      "&:hover": {
        opacity: "0.8",
      },
      "&:disabled": {
        opacity: "0.6",
      },
    },
    outline: {
      color: "#7d7d7d",
      bg: "transparent",
      boxShadow: "inset 0 0 0 2px",
    },
  },
}

const Layout = ({ children, location }) => {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <>
          <Header />
          <div className="mainWrapper">
            <Transition location={location}>{children}</Transition>
          </div>
          <Footer />
        </>
      </ThemeProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
}

export default withTranslation(Layout)
